"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMitekMock = void 0;
const fetchMitekMock = async ({ API, decision, progressId }) => {
    const MITEK_URL = progressId
        ? `${window.MIDDLEWARE_BASE_HOST}/mb-api-crosscore/v1/b3109706f754472f444ad288bb791736/identification`
        : `${window.MIDDLEWARE_BASE_HOST}/mb-api-crosscore/v1/identification`;
    const body = {
        decision,
    };
    const xhrOptions = {};
    if (progressId) {
        xhrOptions.headers = {
            progressId,
        };
    }
    return API.POST(MITEK_URL, body, xhrOptions);
};
exports.fetchMitekMock = fetchMitekMock;
//# sourceMappingURL=mitekMockRepository.js.map